import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveDocument } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function DocumentRemoval({ document, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeDocument } = useRemoveDocument(document);

  return (
    <Modal
      header={t("removeDocument.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>
            {t("removeDocument.message", { documentName: document.name })}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeDocument.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeDocument(document)}
          >
            {t("removeDocument.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { DocumentRemoval };
